module.exports = __webpack_public_path__ + "static/medical-072ebbe47cd77cf5905808f1e568e423.jpg";